import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { learnerIntegrationsService } from '@/services/learnerIntegrationsService';

export const learnerIntegrationsKeys = {
  all: ['me', 'integrations'] as const,
  list: () => [...learnerIntegrationsKeys.all, 'list'] as const,
};

export function useLearnerIntegrations() {
  return useQuery({
    queryKey: learnerIntegrationsKeys.list(),
    queryFn: () => learnerIntegrationsService.list(),
    staleTime: 30_000,
    select: (envelope) => envelope.data,
  });
}

export function useStartLearnerGoogleConnect() {
  return useMutation({
    mutationFn: () => learnerIntegrationsService.startGoogleConnect(),
    onSuccess: (envelope) => {
      window.location.assign(envelope.data.authorize_url);
    },
    onError: (err: any) => {
      const message =
        err?.response?.data?.message ||
        'Could not start Google connect. Please try again.';
      toast.error(message);
    },
  });
}

export function useDisconnectLearnerIntegration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (connectionId: string) =>
      learnerIntegrationsService.disconnect(connectionId),
    onSuccess: () => {
      toast.success('Disconnected');
      queryClient.invalidateQueries({ queryKey: learnerIntegrationsKeys.list() });
    },
    onError: (err: any) => {
      const message =
        err?.response?.data?.message || 'Could not disconnect. Please try again.';
      toast.error(message);
    },
  });
}
